import axios from "axios"

export default {
  fetchMilonDevData(params) {
    return axios.get("/api/milon/dev/data", {
      params,
      headers: { Authorization: localStorage.getItem("token") },
      timeout: 80000,
    }).then((res) => res.data)
  },
}
